<template>
  <img v-if="src" :src="src" v-bind="$attrs" />
</template>
<script>
import axiosFactory from "../services/axios.factory";

// Avatare hingen frueher als <img :src="/api/files/avatar/{id}"> direkt an der API. Ein Browser
// sendet bei Bild-Requests keinen Authorization-Header, deshalb musste der Endpunkt offen sein —
// jeder konnte die Profilbilder aller Benutzer durchzaehlen. Hier wird das Bild stattdessen per
// axios (mit Token) geholt und als Blob-URL angezeigt; damit kann der Endpunkt [Authorize] tragen.
//
// Cache je Benutzer-ID, damit eine Liste mit vielen Zeilen dasselbe Bild nur einmal laedt.
// Die Blob-URLs bleiben fuer die Lebensdauer der Seite bestehen (wenige Benutzer, unkritisch).
const cache = new Map();

function loadAvatar(userId) {
  if (cache.has(userId)) return cache.get(userId);

  const request = axiosFactory()
    .get(`/files/avatar/${userId}`, { responseType: "blob" })
    .then((res) => (res.data && res.data.size ? URL.createObjectURL(res.data) : null))
    .catch(() => null);

  cache.set(userId, request);
  return request;
}

export default {
  name: "UserAvatar",
  inheritAttrs: false,
  props: {
    userId: { type: [Number, String], default: null },
  },
  data() {
    return { src: null };
  },
  watch: {
    userId: {
      immediate: true,
      handler(id) {
        this.src = null;
        if (id === null || id === undefined || id === "") return;
        const requested = id;
        loadAvatar(id).then((url) => {
          // nur uebernehmen, wenn sich die Zeile zwischenzeitlich nicht geaendert hat
          if (this.userId === requested) this.src = url;
        });
      },
    },
  },
};
</script>
